import { Accordion, AccordionProps, AccordionTab } from 'primereact/accordion'
import classes from './UlAccordion.module.scss'

export type UlAccordionProps = {
  children: React.ReactElement<AccordionTab> | React.ReactElement<AccordionTab>[]
} & Omit<AccordionProps, 'transitionOptions'>
export default function UlAccordion({ children, ...props }: UlAccordionProps) {
  return (
    <Accordion
      {...props}
      className={`${classes['ul-accordion']} ${props.className}`}
      transitionOptions={{
        unmountOnExit: false,
        mountOnEnter: false,
        addEndListener: () => {},
      }}
    >
      {children}
    </Accordion>
  )
}
